import * as React from "react";
import { observer } from "mobx-react";
import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Paper,
  PaperProps,
} from "@mui/material";
import Draggable1 from "react-draggable";
import {useRootStore} from "../../store/contexts";
import {LoginForm} from "./LoginForm";
const Draggable: any = Draggable1;

type SessionExpiredDialogProps = {
  open: boolean;
  onClose: () => void;
};

export const SessionExpiredDialog: React.FC<SessionExpiredDialogProps> = observer(
  ({ open, onClose }) => {
    const rootStore = useRootStore();
    const { langStore} = rootStore;

    const PaperComponent = (props: PaperProps) => {
      const nodeRef = React.useRef(null);
      return (
        <Draggable
          nodeRef={nodeRef}
          handle="#draggable-dialog-title"
          cancel={'[class*="MuiDialogContent-root"]'}
        >
          <Paper ref={nodeRef} {...props} />
        </Draggable>
      );
    };

    return (
      <Dialog
        open={open}
        onClose={() => onClose()}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
          {langStore.sessionExpiredTitle}
        </DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ mb: 2 }}>
            {langStore.sessionExpiredMessage}
          </DialogContentText>
          <LoginForm embedded={true} onLoginSuccess={() => onClose()} />
        </DialogContent>
      </Dialog>
    );
  }
);
